/* KÔBO — Labo d'extraction de l'accueil.
   Ce fichier ne contient QUE du DOM et du calcul : il tourne partout, y compris
   sur les téléphones les plus lents. La scène WebGL est un supplément, chargée
   dynamiquement et uniquement si la machine peut la tenir (voir canGL plus bas).
   Sans elle, le dégradé SVG reçoit les mêmes couleurs : rien ne manque. */
(function () {
  var root = document.querySelector('[data-k-labo]');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  var ins = {}, outs = {};
  $$('[data-in]').forEach(function (i) { ins[i.dataset.in] = i; });
  $$('[data-out]').forEach(function (o) { outs[o.dataset.out] = o; });

  var cv = $('.k-labo-cv'), cstops = $$('[data-cstop]');

  /* Même modèle que le Labo de la fiche produit (kobo-m-lab.js) : débit, rendement,
     ratio, puis taux d'extraction, puis les axes gustatifs. Dupliqué volontairement
     plutôt que partagé — deux pages, deux chargements, aucune dépendance croisée. */
  function params() { return { g: +ins.grind.value, d: +ins.dose.value, T: +ins.temp.value, t: +ins.time.value }; }

  function model(p) {
    var flow = (0.85 + 0.24 * p.g) * Math.pow(18 / p.d, 0.5);
    var Y = flow * p.t, ratio = Y / p.d;
    /* Le ratio est un RÉSULTAT de la mouture, pas un levier indépendant : le faire
       entrer dans le calcul revenait à compter la mouture deux fois, avec des signes
       opposés. Les deux s'annulaient et l'extraction restait bloquée à ~20,5 % quelle
       que soit la mouture. L'extraction se calcule donc sur les leviers réellement
       indépendants : surface (mouture), température, temps de contact et dose. */
    var E = clamp(20.5 + 0.55 * (p.T - 93) + 1.05 * (5 - p.g) + 0.075 * (p.t - 28) + 0.25 * (18 - p.d), 12, 28);
    var v;
    if (E < 17.5) v = { t: 'Sous-extrait', c: 'under', p: 'Acide et court en bouche. Mouds plus fin, allonge le temps ou monte la température.' };
    else if (E > 22.5) v = { t: 'Sur-extrait', c: 'over', p: 'Amer et asséchant. Mouds plus gros, raccourcis le temps ou baisse la température.' };
    else v = { t: 'Équilibré', c: 'ok', p: 'Sucrosité, acidité et corps se tiennent. Note cette recette, c’est la bonne.' };
    return { flow: flow, Y: Y, ratio: ratio, E: E, v: v };
  }

  function colorFor(E) {
    var t = clamp((E - 14) / 12, 0, 1), a = [215, 160, 101], b = [141, 84, 36], c = [42, 20, 8];
    var mix = function (x, y, k) { return [Math.round(x[0] + (y[0] - x[0]) * k), Math.round(x[1] + (y[1] - x[1]) * k), Math.round(x[2] + (y[2] - x[2]) * k)]; };
    return t < 0.5 ? mix(a, b, t / 0.5) : mix(b, c, (t - 0.5) / 0.5);
  }
  var rgb = function (c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; };

  var state = { p: null, m: null };

  function render() {
    var p = params(), m = model(p);
    state.p = p; state.m = m;

    outs.grind.textContent = String(p.g).replace('.', ',');
    outs.dose.textContent = p.d + ' g';
    outs.temp.textContent = p.T + ' °C';
    outs.time.textContent = p.t + ' s';
    $('[data-stat=yield]').textContent = m.Y.toFixed(1).replace('.', ',') + ' g';
    $('[data-stat=ratio]').textContent = '1 : ' + m.ratio.toFixed(2).replace('.', ',');
    $('[data-stat=ext]').textContent = m.E.toFixed(1).replace('.', ',') + ' %';
    $('[data-labo-ext]').textContent = m.E.toFixed(1).replace('.', ',') + ' %';
    $('[data-sweet]').style.left = clamp((m.E - 14) / 12, 0, 1) * 100 + '%';

    var vEl = $('[data-verdict]');
    vEl.className = 'k-verdict ' + m.v.c;
    vEl.innerHTML = '<b>' + m.v.t + '</b><p>' + m.v.p + '</p>';

    /* Le repli SVG reçoit exactement les couleurs du shader. */
    if (cstops.length === 3) {
      cstops[0].setAttribute('stop-color', rgb(colorFor(m.E - 5)));
      cstops[1].setAttribute('stop-color', rgb(colorFor(m.E)));
      cstops[2].setAttribute('stop-color', rgb(colorFor(m.E + 5)));
    }
    if (window.KOBO_LABO_GL) window.KOBO_LABO_GL.set(m.E, p);

    var shop = $('[data-labo-shop]');
    if (shop) shop.textContent = m.v.c === 'ok' ? 'Le café qui va avec' : 'Ce qu’il te faut';
  }

  /* ---------- export PNG ---------- */
  function exportCard() {
    var W = 1200, H = 630, c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d'), p = state.p, m = state.m;

    x.fillStyle = '#000'; x.fillRect(0, 0, W, H);

    /* disque de crema, mêmes couleurs que la scène */
    var cx = 300, cy = H / 2, R = 200;
    var g = x.createRadialGradient(cx - R * 0.24, cy - R * 0.28, R * 0.1, cx, cy, R);
    g.addColorStop(0, rgb(colorFor(m.E - 5)));
    g.addColorStop(0.55, rgb(colorFor(m.E)));
    g.addColorStop(1, rgb(colorFor(m.E + 5)));
    x.beginPath(); x.arc(cx, cy, R, 0, Math.PI * 2); x.fillStyle = g; x.fill();
    x.strokeStyle = 'rgba(255,255,255,.25)'; x.lineWidth = 2; x.stroke();

    var L = 580;
    x.fillStyle = '#fff';
    x.font = '700 30px Archivo, system-ui, sans-serif';
    x.fillText('KÔBO', L, 96);
    x.fillStyle = '#b5734a';
    x.font = '500 15px "IBM Plex Mono", monospace';
    x.fillText('PROFIL D’EXTRACTION', L, 126);

    x.fillStyle = '#fff';
    x.font = '700 66px Archivo, system-ui, sans-serif';
    x.fillText(m.v.t, L, 206);

    x.font = '500 17px "IBM Plex Mono", monospace';
    var rows = [
      ['Mouture', String(p.g).replace('.', ',')],
      ['Dose', p.d + ' g'],
      ['Température', p.T + ' °C'],
      ['Temps', p.t + ' s'],
      ['Rendement', m.Y.toFixed(1).replace('.', ',') + ' g'],
      ['Ratio', '1 : ' + m.ratio.toFixed(2).replace('.', ',')],
      ['Extraction', m.E.toFixed(1).replace('.', ',') + ' %']
    ];
    rows.forEach(function (r, i) {
      var y = 264 + i * 40;
      x.fillStyle = '#8b8882'; x.fillText(r[0], L, y);
      x.fillStyle = i === 6 ? '#b5734a' : '#fff';
      x.textAlign = 'right'; x.fillText(r[1], W - 70, y); x.textAlign = 'left';
      x.strokeStyle = 'rgba(255,255,255,.10)'; x.lineWidth = 1;
      x.beginPath(); x.moveTo(L, y + 13); x.lineTo(W - 70, y + 13); x.stroke();
    });

    x.fillStyle = '#5f5d59';
    x.font = '400 14px Archivo, system-ui, sans-serif';
    x.fillText('kobobarista.com — atelier à Mulhouse', L, H - 44);

    return c.toDataURL('image/png');
  }

  var png = $('[data-labo-png]');
  if (png) {
    png.addEventListener('click', function () {
      /* href posé au moment du clic : l'image doit refléter les réglages courants. */
      try { png.href = exportCard(); } catch (e) { png.removeAttribute('href'); }
    });
  }

  /* Remplissage de la piste des curseurs : kobo-m-fx.js le fait sur les fiches
     produit, mais ce fichier n'est pas chargé sur l'accueil. */
  function fill(i) { i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min) * 100) + '%'); }

  Object.keys(ins).forEach(function (k) {
    fill(ins[k]);
    ins[k].addEventListener('input', function () { fill(ins[k]); render(); });
  });
  render();

  /* ---------- scène WebGL : desktop capable uniquement ---------- */
  function canGL() {
    if (window.innerWidth < 1000) return false;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4) return false;
    try {
      var t = document.createElement('canvas');
      return !!(t.getContext('webgl') || t.getContext('experimental-webgl'));
    } catch (e) { return false; }
  }

  if (!cv || !canGL()) { root.classList.add('no-gl'); return; }

  /* Chargé seulement ici : sur mobile le fichier n'est jamais téléchargé. */
  var loaded = false;
  function loadGL() {
    if (loaded) return;
    loaded = true;
    var s = document.createElement('script');
    s.src = cv.dataset.gl || (window.KOBO_LABO_GL_SRC || '');
    s.defer = true;
    s.onload = function () { if (window.KOBO_LABO_GL) { window.KOBO_LABO_GL.init(cv); render(); } };
    s.onerror = function () { root.classList.add('no-gl'); };
    document.head.appendChild(s);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { loadGL(); io.disconnect(); } });
    }, { rootMargin: '400px 0px' });
    io.observe(root);
  } else { loadGL(); }
})();
